import React from "react";
import { ScreenData } from "../../types/ScreenTypes";
import { formatDurationLabel } from "../../utils/formatDuration";
import "./FullscreenCountdownTakeover.css";

interface FullscreenCountdownTakeoverProps {
  prayerName: string | null;
  seconds: number;
  screenData: ScreenData;
}

function normalizeFormatStyle(
  style: ScreenData["countdownTimeFormatStyle"],
): "short" | "medium" | "long" | "digital" {
  if (!style) {
    return "long";
  }

  const normalized = style.toLowerCase();
  if (
    normalized === "short" ||
    normalized === "medium" ||
    normalized === "long" ||
    normalized === "digital"
  ) {
    return normalized;
  }

  return "long";
}

export default function FullscreenCountdownTakeover({
  prayerName,
  seconds,
  screenData,
}: FullscreenCountdownTakeoverProps) {
  const prayerLabel = prayerName || "Next Salah";
  const timeLabel = formatDurationLabel(
    seconds,
    normalizeFormatStyle(screenData.countdownTimeFormatStyle),
  );

  const style = {
    "--countdown-primary": screenData.countdownTextColor || "#FF0000",
    "--countdown-text": screenData.headingTextColor || "#ffffff",
    "--countdown-title-color":
      screenData.countdownTitleColor ||
      screenData.headingTextColor ||
      "#ffffff",
    "--countdown-bg":
      screenData.countdownBackgroundColor ||
      screenData.widgetBackgroundColor ||
      "#0f172a",
    "--countdown-bg-image": screenData.countdownBackgroundUrl
      ? `url("${screenData.countdownBackgroundUrl}")`
      : "none",
    "--countdown-title-scale": `${
      (screenData.countdownTitleFontScalePercent &&
      screenData.countdownTitleFontScalePercent > 0
        ? Math.min(600, Math.max(60, screenData.countdownTitleFontScalePercent))
        : 100) / 100
    }`,
    "--countdown-title-weight": `${
      screenData.countdownTitleFontWeight &&
      screenData.countdownTitleFontWeight > 0
        ? Math.min(900, Math.max(400, screenData.countdownTitleFontWeight))
        : 700
    }`,
    "--countdown-value-scale": `${
      (screenData.countdownValueFontScalePercent &&
      screenData.countdownValueFontScalePercent > 0
        ? Math.min(600, Math.max(60, screenData.countdownValueFontScalePercent))
        : 100) / 100
    }`,
    "--countdown-value-weight": `${
      screenData.countdownValueFontWeight &&
      screenData.countdownValueFontWeight > 0
        ? Math.min(900, Math.max(400, screenData.countdownValueFontWeight))
        : 500
    }`,
  } as React.CSSProperties;

  return (
    <div className="fullscreen-countdown" style={style}>
      <div className="fullscreen-countdown-inner">
        <div className="fullscreen-countdown-title">{prayerLabel} in</div>
        <div className="fullscreen-countdown-value">{timeLabel}</div>
      </div>
    </div>
  );
}
